


































import { Component, Vue, Watch } from 'vue-property-decorator';
import { home, message, userCenter } from '@/routers/routerConfig';
import { UnreadMessageResponse } from '@/services/__model';
import { MessageController } from '@/services/request.service';

@Component
export default class Menu extends Vue {
  public list: Array<UnreadMessageResponse> = [];
  public menuKeys: string[] = [];
  public subRoutes: any = {
    home,
    message,
    userCenter,
  };

  @Watch('$route', { immediate: true })
  public getMenuKeys(): void {
    const name: string = this.$route.name ? this.$route.name : '';
    if (name.indexOf('Detail') === -1) {
      this.menuKeys = [this.$route.name!];
    } else {
      const pathName = this.$route.path.split('/');
      this.menuKeys = [pathName[pathName.length - 2]];
    }
  }

  public get rootMenuOpenKeys(): string[] {
    return Object.keys(this.subRoutes);
  }

  public created(): void {
    this.getUnreadMsg();
  }

  public get menus(): object[] {
    return this.subRoutes;
  }

  public getUnreadMsg(): void {
    MessageController.getUnreadMessageList().then(res => {
      this.list = res.data ? res.data : [];
      let total: number = 0;
      this.list.forEach(item => {
        total += item.unreadMessageNum;
      });
      this.$store.commit('setNewMessageNum', total);
    });
  }

  public clickLeftMenu({ key }: { key: string }): void {
    const fun = 'click';
    if (this.$listeners[fun]) {
      this.$emit('click');
    }
    this.$router.push({ name: key }).catch(err => {});
  }
}
